import { BsGear } from "react-icons/bs";
import { BiBarChartSquare } from "react-icons/bi";
import { GrProjects } from "react-icons/gr";
import { SiGithubactions } from "react-icons/si";

import {
  AiOutlineDashboard,
  AiOutlineLogout,
  AiOutlineLineChart,
  AiOutlinePieChart,
  AiOutlineProject,
  AiOutlineInsertRowLeft,
  AiOutlinePicLeft,
  AiOutlineAlibaba,
  AiOutlineOrderedList,
  AiOutlineCustomerService,
  AiOutlineAppstore,
  AiTwotoneProject,
} from "react-icons/ai";
import { FiFileText, FiUsers } from "react-icons/fi";
import React from "react";
import { RiListCheck2 } from "react-icons/ri";

const menu = [
  {
    id: "dashboard",
    name: "داشبورد",
    icon: <AiOutlineDashboard />,
    path: "/dashboard",
    disabled: false,
  },
  {
    id: "shop",
    name: "فروشگاه ها",
    icon: <AiOutlineAppstore />,
    path: "/shop",
    disabled: false,
  },
  {
    id: "category",
    name: "گروه محصولات",
    icon: <AiTwotoneProject />,
    path: "/category",
    disabled: false,
  },
  {
    id: "product",
    name: " محصولات",
    icon: <AiOutlineProject />,
    path: "/product",
    disabled: false,
  },
  {
    id: "customer",
    name: " مشتریان",
    icon: <AiOutlineCustomerService />,
    path: "/customer",
    disabled: false,
  },
  {
    id: "order",
    name: " لیست سفارشات فروشگاه",
    icon: <AiOutlineOrderedList />,
    path: "/order",
    disabled: false,
  },

  {
    id: "logout",
    name: "خروج",
    icon: <AiOutlineLogout />,
    path: "/login",
    disabled: false,
  },
];

export default menu;
